/**
 * NetworkInfo module handles network connectivity monitoring and status management
 */
export default class NetworkInfo {
    isOnline = true;
    isOnlinePromise = null;
    isOnlineResolve = null;
    init() {
        this.setupNetworkMonitoring();
    }
    /**
     * Get current online status
     * @returns true if online, false if offline
     */
    getOnlineStatus() {
        return this.isOnline;
    }
    /**
     * Wait for network to come back online
     * @returns A promise that resolves when network is online
     */
    async waitForOnline() {
        if (this.isOnline) {
            return;
        }
        if (!this.isOnlinePromise) {
            this.isOnlinePromise = new Promise((resolve) => {
                this.isOnlineResolve = resolve;
            });
        }
        return this.isOnlinePromise;
    }
    /**
     * Setup network connectivity monitoring
     */
    setupNetworkMonitoring() {
        // Check initial network status
        this.isOnline = navigator.onLine;
        // Listen for online/offline events
        window.addEventListener('online', this.handleOnline.bind(this));
        window.addEventListener('offline', this.handleOffline.bind(this));
    }
    /**
     * Handle network coming online
     */
    handleOnline() {
        this.isOnline = true;
        this.isOnlineResolve?.();
    }
    /**
     * Handle network going offline
     */
    handleOffline() {
        this.isOnline = false;
        this.isOnlinePromise = null;
        this.isOnlineResolve = null;
    }
    /**
     * Cleanup method to remove event listeners
     * Should be called when the NetworkInfo instance is no longer needed
     */
    destroy() {
        window.removeEventListener('online', this.handleOnline.bind(this));
        window.removeEventListener('offline', this.handleOffline.bind(this));
    }
}
